import { fetchExportInvoiceApi } from "api/invoice";
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { STATUS } from "../const";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";
import { useToasts } from "react-toast-notifications";
const moment = require("moment");

const useInvoiceExport = (role) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments[pathSegments.length - 1];
  const { addToast } = useToasts();

  const handleExportInvoiceApi = useCallback(
    async (dates = {}) => {
      const bodyData = {
        role: role,
        startDate: dates?.startDate || new Date().toISOString(),
        endDate: dates?.endDate || new Date().toISOString(),
      };

      try {
        const response = await fetchExportInvoiceApi(id, bodyData);
        console.log("response", response);

        return response?.data || response;
      } catch (error) {
        console.error("API error while exporting invoice datasets:", error);
        throw error;
      }
    },
    [id, role],
  );
  const mainCols = [
    {
      columnName: "Proforma Invoice Number",
      name: "pfiNo",
    },
    {
      columnName: "Invoice No.",
      name: "inNo",
    },
    {
      columnName: "Invoice Type",
      name: "docType",
    },
    {
      columnName: "Invoice Date",
      name: "inDt",
      type: "date",
    },
    {
      columnName: "Proforma Issue Date",
      name: "pfiDt",
    },
    {
      columnName: "Title",
      name: "sub",
    },
    {
      columnName: "Payment Terms (Net Days)",
      name: "trms",
    },
    {
      columnName: "Office Location",
      name: "ofcId",
    },
    {
      columnName: "Customer Remarks",
      name: "rmks",

      ctrl: "textarea",
    },
    {
      columnName: "Client Name",
      name: "cId",
    },
    {
      columnName: "Project",
      name: "pId",
    },
    {
      columnName: "Currency",
      name: "cur",
    },
    {
      columnName: "Customer Tax ID",
      name: "txId",
    },
    {
      columnName: "Major Category",
      name: "mjId",
    },
    {
      columnName: "Minor Category",
      name: "mnId",
    },
    {
      columnName: "Sub Minor Category",
      name: "subMnId",
    },
    {
      columnName: "Status",
      name: "sts",
    },
    {
      columnName: "Status Date",
      name: "stsDate",
    },
    {
      columnName: "Adjustment",
      name: "adjAmt",
    },
  ];

  const childSheets = {
    items: {
      sheetTitle: "Line Items",
      sheetKey: "items",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "Product / Service",
          name: "salesItemId",
        },
        {
          columnName: "Name",
          name: "name",
        },
        {
          columnName: "HSN/SAC",
          name: "code",
          type: "string",

          sampleVal: "8471",
        },
        {
          columnName: "Details",
          name: "des",

          ctrl: "textarea",
        },
        {
          columnName: "Qty",
          name: "qty",
        },
        {
          columnName: "Rate",
          name: "prc",
        },
        {
          columnName: "Taxes",
          name: "txPrc",
        },
        {
          columnName: "TDS",
          name: "tdsPrc",
        },
        {
          columnName: "Line Total",
          name: "total",
        },
      ],
    },
    payments: {
      sheetTitle: "Payments",
      sheetKey: "payments",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "Payment ID",
          name: "pmtNo",
        },
        {
          columnName: "Date",
          name: "dt",
        },
        {
          columnName: "Total Amount",
          name: "amt",
          sampleVal: "8471",
        },
        {
          columnName: "Bank Charges",
          name: "bnkCrg",
          sampleVal: "Purchase of laptop for office use",
        },
        {
          columnName: "TDS Deduction",
          name: "ttlTds",

          ctrl: "number",
        },
        {
          columnName: "Payment mode",
          name: "mod",
        },
        {
          columnName: "Payment Date",
          name: "payModDt",
        },
        {
          columnName: "Reference number",
          name: "ref",
        },
        {
          columnName: "Status",
          name: "sts",
        },
        {
          columnName: "Modified",
          name: "stsDate",
        },
      ],
    },
    purchaseOrder: {
      sheetTitle: "Purchase orders",
      sheetKey: "purchaseOrder",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "PO Number",
          name: "odrNo",
        },
        {
          columnName: "Issue Date",
          name: "odrDt",
        },
        {
          columnName: "Notes",
          name: "purRmks",
          sampleVal: "8471",
        },
        {
          columnName: "Supporting Docs",
          name: "purFile",
          sampleVal: "Purchase of laptop for office use",
        },
        {
          columnName: "Attachment Date",
          name: "invPurAttachDt",

          ctrl: "number",
        },
        {
          columnName: "Approval Status",
          name: "sts",
        },
        {
          columnName: "Modified Date",
          name: "stsDate",
        },
      ],
    },
    taxes: {
      sheetTitle: "Tax",
      sheetKey: "taxes",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "Item Information",
          name: "des",
        },
        {
          columnName: "Taxable Amount",
          name: "txAmt",
        },
        {
          columnName: "IGST",
          name: "igst",
        },
        {
          columnName: "CGST",
          name: "cgst",
        },
        {
          columnName: "SGST",
          name: "sgst",
        },
        {
          columnName: "Total",
          name: "ttlGst",
        },
      ],
    },
    tds: {
      sheetTitle: "TDS",
      sheetKey: "tds",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "Item Information",
          name: "des",
        },
        {
          columnName: "Total Amount",
          name: "txAmt",
        },
        {
          columnName: "TDS (%)",
          name: "tds",
        },
        {
          columnName: "TDS Amount",
          name: "ttlTds",
        },
      ],
    },
    credits: {
      sheetTitle: "Credits",
      sheetKey: "credits",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "Credit Note",
          name: "crId",
        },
        {
          columnName: "Date",
          name: "crDate",
        },
        {
          columnName: "Credit Number",
          name: "crNo",
        },
        {
          columnName: "Available Amount",
          name: "avAmt",
        },
        {
          columnName: "Utilized Amount",
          name: "usAmt",
        },
        {
          columnName: "Utilized",
          name: "usDate",
        },
        {
          columnName: "Attachment",
          name: "invCrAttach",
        },
        {
          columnName: "Attachment Date",
          name: "invCrAttachDt",
        },
        {
          columnName: "Remarks",
          name: "creditRmks",
        },
        {
          columnName: "Status",
          name: "sts",
        },
        {
          columnName: "Modified",
          name: "stsDate",
        },
      ],
    },

    refunds: {
      sheetTitle: "Refunds",
      sheetKey: "refunds",
      firstColumn: {
        columnName: "Proforma / Invoice Number",
        name: "pfiNo",
      },
      cols: [
        {
          columnName: "Refund Details",
          name: "rfNo",
        },
        {
          columnName: "Date",
          name: "rfDate",
        },
        {
          columnName: "Amount",
          name: "amt",
        },
        {
          columnName: "Payment mode",
          name: "mod",
        },
        {
          columnName: "Payment Received Date",
          name: "pymtRxDate",
        },
        {
          columnName: "Reference No.",
          name: "ref",
        },
        {
          columnName: "Reason",
          name: "rsn",
        },
        {
          columnName: "Attachment",
          name: "invRfAttach",
        },
        {
          columnName: "Attachment Date",
          name: "invRfAttachDt",
        },
        {
          columnName: "Status",
          name: "sts",
        },
        {
          columnName: "Modified Date",
          name: "stsDate",
        },
      ],
    },
  };

  const handleGetFreshColumns = useCallback(
    async (dateFilters) => {
      const apiResponse = await handleExportInvoiceApi(dateFilters);
      const rawRecords = Array.isArray(apiResponse)
        ? apiResponse
        : apiResponse?.data || [];

      if (rawRecords.length === 0) {
        addToast(
          `No invoice records were found for the specified date range.`,
          {
            appearance: "error",
          },
        );

        return;
      }

      // Map complex nested structure fields to match mainCols keys
      const flattenedRecords = rawRecords.map((record) => {
        const pfiString =
          record.pfiNo && record.pfiNo.n
            ? `${record.pfiNo.prfx || ""}${record.pfiNo.n}`
            : "";
        const invString =
          record.inNo && record.inNo.n
            ? `${record.inNo.prfx || ""}${record.inNo.n}`
            : "";

        // Normalize line items array location from inside record.pyInfo.itms
        const rawItms = record.pyInfo?.itms || record.items || [];

        const formattedItems = rawItms.map((item) => ({
          parent: item.parent,
          salesItemId: item.slItm?.name || "",
          name: item.slItm?.name || "",
          code: item.slItm?.hCd || "",
          des: item.slItm?.dc || "",
          qty: item.qty !== undefined ? item.qty : "",
          prc: item.prc !== undefined ? item.prc : "",
          txPrc: item.tax?.percentage || "",
          tdsPrc: item.tdsPrc || "",
          total: item.amt !== undefined ? item.amt : "",
        }));

        const getPaymentMode = (id) => {
          const payMod = allPaymentMode.find((opt) => opt.id === id);
          return payMod?.value || "";
        };

        let resolvedParentId = "";

        if (record.isInv) {
          resolvedParentId = invString;
        } else if (!record.isPfi) {
          resolvedParentId = pfiString;
        }

        // TDS sheet

        const rawTds =
          record.tdsApl?.tdsRc || record.tds || record.pyInfo?.tds || [];
        const nestedTds = Array.isArray(rawTds) ? rawTds : [rawTds];

        const formattedTds = nestedTds
          .map((t) => {
            if (!t || typeof t !== "object") return null;
            return {
              pfiNo: resolvedParentId,
              parent: resolvedParentId,
              des: t.des || "TDS Deduction",
              txAmt:
                t.bsAmt !== undefined
                  ? t.bsAmt
                  : t.txAmt !== undefined
                    ? t.txAmt
                    : "",
              tds:
                t.prc !== undefined ? t.prc : t.tds !== undefined ? t.tds : "",
              ttlTds:
                t.tdsAmt !== undefined
                  ? t.tdsAmt
                  : t.ttlTds !== undefined
                    ? t.ttlTds
                    : "",
            };
          })
          .filter(Boolean);

        // TDS Sheet end

        const pyInfoObj =
          record.pyInfo && !Array.isArray(record.pyInfo) ? record.pyInfo : {};

        const nestedPayments = Array.isArray(record.pmtRc)
          ? record.pmtRc
          : Array.isArray(record.payments)
            ? record.payments
            : [];

        const formattedPayments = nestedPayments.map((pmt, index) => {
          // Payment number comes from pmtRc.pyNo
          let computedPmtNo = "";

          if (pmt.pyNo && typeof pmt.pyNo === "object") {
            const mm = String(pmt.pyNo.m || "").padStart(2, "0");
            const yy = String(pmt.pyNo.y || "").slice(-2);
            const nn = String(pmt.pyNo.n || "").padStart(2, "0");

            computedPmtNo = `${pmt.pyNo.prfx || ""}${mm}${yy}-${nn}`;
          } else if (pmt.pNo) {
            computedPmtNo = pmt.pNo;
          } else if (pyInfoObj.pNo) {
            computedPmtNo = pyInfoObj.pNo;
          }

          // Status comes from pyInfo
          const resolvedSts =
            pyInfoObj.sts !== undefined
              ? STATUS[pyInfoObj.sts]
              : pmt.sts !== undefined
                ? STATUS[pmt.sts]
                : "";
          const correspondingTds = formattedTds[index] || {};
          return {
            parent: pmt.parent || pyInfoObj.parent || "",

            // From pmtRc
            pmtNo: computedPmtNo,

            dt: pmt.dt ? moment(pmt.dt).format("DD-MM-YYYY") : "",

            amt: pmt.amt !== undefined ? pmt.amt : "",

            // pmtRc.crg -> payment object's bnkCrg
            bnkCrg: pmt.crg !== undefined ? pmt.crg : "",

            // ttlTds: pmt.ttlTds !== undefined ? pmt.ttlTds : "",
            ttlTds:
              pmt.ttlTds !== undefined
                ? pmt.ttlTds
                : correspondingTds.ttlTds !== undefined
                  ? correspondingTds.ttlTds
                  : "",

            // pmtRc.mod -> payment object's mod
            mod: pmt.mod !== undefined ? getPaymentMode(pmt.mod) : "",

            // pyInfo.pDt -> payment object's payModDt
            payModDt: pyInfoObj.pDt
              ? moment(pyInfoObj.pDt).format("DD-MM-YYYY")
              : "",

            // pmtRc.ref -> payment object's ref
            ref: pmt.ref || "",

            // pyInfo.sts -> payment object's sts
            sts: resolvedSts,

            stsDate: pmt.stsDate || "",
          };
        });

        const rawPurchaseOrder =
          record.purchaseOrder || record.pyInfo?.purchaseOrder;
        let formattedPurchaseOrders = [];

        if (
          rawPurchaseOrder &&
          (Array.isArray(rawPurchaseOrder)
            ? rawPurchaseOrder.length > 0
            : Object.keys(rawPurchaseOrder).length > 0)
        ) {
          const nestedPurchaseOrders = Array.isArray(rawPurchaseOrder)
            ? rawPurchaseOrder
            : [rawPurchaseOrder];
          formattedPurchaseOrders = nestedPurchaseOrders
            .map((po) => {
              if (!po || typeof po !== "object") return null;

              const rawOdrDt =
                po.pDt || po.odrDt || record.pyInfo?.pDt || record.inDt || "";
              return {
                pfiNo: resolvedParentId,
                parent: resolvedParentId,
                odrNo:
                  po.pNo || po.odrNo || record.pyInfo?.pNo || record.pNo || "",
                odrDt: moment(rawOdrDt).format("DD-MM-YYYY") || "",
                purRmks: po.purRmks || po.notes || "",
                purFile: po.purFile || po.supportingDocs || "",
                invPurAttachDt: po.invPurAttachDt || po.attachmentDate || "",
                sts: po.sts !== undefined ? STATUS[po.sts] || po.sts : "",
                stsDate: moment(rawOdrDt).format("DD-MM-YYYY") || "",
              };
            })
            .filter(Boolean);
        } else if (record.pNo || record.pyInfo?.pNo) {
          // Synthesizes a row directly from parent details when sub-arrays are missing or empty
          const rawOdrDt = record.pyInfo?.pDt || record.inDt || "";

          formattedPurchaseOrders.push({
            pfiNo: resolvedParentId,
            parent: resolvedParentId,
            odrNo: record.pyInfo?.pNo || record.pNo || "",
            odrDt: moment(rawOdrDt).format("DD-MM-YYYY") || "",
            purRmks: record.purRmks || "",
            purFile: record.purFile || "",
            invPurAttachDt: record.invPurAttachDt || "",
            sts:
              record.sts !== undefined ? STATUS[record.sts] || record.sts : "",
            stsDate: moment(rawOdrDt).format("DD-MM-YYYY") || "",
          });
        }

        const rawRefunds = record.rfdInfo?.list || [];
        const nestedRefunds = Array.isArray(rawRefunds)
          ? rawRefunds
          : [rawRefunds];

        const formattedRefunds = nestedRefunds
          .map((rf) => {
            if (!rf || typeof rf !== "object") return null;

            const computedParent = rf.parent || resolvedParentId;
            const rawRfDate = rf.pmtDt || rf.rfDate || "";
            const rwaPyDate = rf.pmtDt || rf.pymtRxDate || "";

            return {
              pfiNo: computedParent,
              parent: computedParent,
              refNo: rf.rfNo || "",
              rfNo: rf.rfNo || "",
              rfDate: moment(rawRfDate).format("DD-MM-YYYY") || "",
              amt: rf.amt !== undefined ? rf.amt : "",
              mod: rf.moId
                ? getPaymentMode(rf.moId)
                : rf.mod
                  ? getPaymentMode(rf.mod)
                  : "",
              pymtRxDate: moment(rwaPyDate).format("DD-MM-YYYY") || "",
              ref: rf.rfNo || "",
              rsn: rf.rsn || "",
              invRfAttach: rf.invRfAttach || "",
              invRfAttachDt: rf.invRfAttachDt || "",
              sts: rf.sts !== undefined ? STATUS[rf.sts] || rf.sts : "",
              stsDate: rf.stsDate || "",
            };
          })
          .filter(Boolean);

        const rawCredits =
          record.credits || record.crApl?.list || record.pyInfo?.credits || [];
        const nestedCredits = Array.isArray(rawCredits)
          ? rawCredits
          : [rawCredits];

        const formattedCredits = nestedCredits
          .map((item) => {
            if (!item || typeof item !== "object") return null;

            const crObj =
              item.crId && typeof item.crId === "object" ? item.crId : {};

            let computedCrNo = "";
            if (crObj.crNo && typeof crObj.crNo === "object") {
              const mm = String(crObj.crNo.m || "").padStart(2, "0");
              const yy = String(crObj.crNo.y || "").slice(-2);
              const nn = String(crObj.crNo.n || "").padStart(2, "0");
              computedCrNo = `${crObj.crNo.prfx || ""}${mm}${yy}-${nn}`;
            }

            const computedParent =
              item.parent || record.parent || resolvedParentId;
            const rawPaymentDate = crObj.pmtDt || crObj.crAt || "";

            const rawUsedDate = item.upAt || crObj.upAt || "";
            return {
              pfiNo: computedParent,
              parent: computedParent,
              crId: "",
              crDate: moment(rawPaymentDate).format("DD-MM-YYYY") || "",
              crNo: computedCrNo,
              avAmt: crObj.amt !== undefined ? crObj.amt : "",
              usAmt:
                item.usAmt !== undefined
                  ? item.usAmt
                  : crObj.usAmt !== undefined
                    ? crObj.usAmt
                    : "",
              usDate: moment(rawUsedDate).format("DD-MM-YYYY") || "",
              invCrAttach: crObj.fils?.key || "",
              invCrAttachDt: crObj.invCrAttachDt || "",
              creditRmks: crObj.rmks || "",
              sts:
                record.crApl?.sts !== undefined
                  ? record.crApl.sts
                    ? "approved"
                    : "rejected"
                  : "",
              stsDate: item.stsDate || "",
            };
          })
          .filter(Boolean);

        const rawTaxes =
          record.gstRc || record.taxes || record.pyInfo?.taxes || [];
        const nestedTaxes = Array.isArray(rawTaxes) ? rawTaxes : [rawTaxes];

        const formattedTaxes = nestedTaxes
          .map((t) => {
            if (!t || typeof t !== "object") return null;
            const igstVal = t.amt?.i !== undefined ? t.amt.i : 0;
            const cgstVal = t.amt?.c !== undefined ? t.amt.c : 0;
            const sgstVal = t.amt?.s !== undefined ? t.amt.s : 0;
            const totalGstVal = igstVal + cgstVal + sgstVal;

            return {
              pfiNo: resolvedParentId,
              parent: resolvedParentId,
              des: t.des || "GST Tax Entry",
              txAmt:
                t.bsAmt !== undefined
                  ? t.bsAmt
                  : t.txAmt !== undefined
                    ? t.txAmt
                    : "",
              igst: igstVal,
              cgst: cgstVal,
              sgst: sgstVal,
              ttlGst: t.ttlGst !== undefined ? t.ttlGst : totalGstVal,
            };
          })
          .filter(Boolean);

        // Safely fall back to fallback flat structures or nested keys across sheets
        return {
          ...record,
          pfiNo: record.isPfi ? pfiString : "",
          inNo: record.isInv ? invString : "",
          docType:
            record.isInv && record.isPfi
              ? "Both"
              : record.isInv
                ? "Tax Invoice"
                : record.isPfi
                  ? "Proforma"
                  : record.docType || "",

          inDt: record.inDt ? moment(record.inDt).format("DD-MM-YYYY") : "",
          pfiDt: record.pfiDt ? moment(record.pfiDt).format("DD-MM-YYYY") : "",
          sub: record.invSub || "",
          trms: record.tDays || 0,
          ofcId: record.ofcId || "",
          rmks: record.rmks || "",
          cId: record.clId?.clName || "",
          pId: record.prId?.prj || "",
          cur:
            record.inCr === "" || record.inCr === "undefined"
              ? null
              : record.inCr,
          txId: record.clId?.gsts?.[0]?.gstNo || record.clId?.pnNo || "",
          mjId: record.mjId?.lab || record.mjId?.val || "",
          mnId: record.mnId?.lab || record.mnId?.val || "",
          subMnId: record.msId?.lab || record.msId?.val || "",
          sts: STATUS[record.pyInfo?.sts] || "approved",
          stsDate:
            record.inDt || record.pfiDt
              ? moment(record.inDt || record.pfiDt).format("DD-MM-YYYY")
              : moment().format("DD-MM-YYYY"),

          adjAmt: record.adjAmt || "",
          // Dynamic sub-array properties
          items: formattedItems,
          payments: formattedPayments,
          purchaseOrder: formattedPurchaseOrders,
          taxes: formattedTaxes,
          tds: formattedTds,
          credits: formattedCredits,
          refunds: formattedRefunds,
        };
      });

      return { mainCols, childSheets, records: flattenedRecords };
    },
    [handleExportInvoiceApi, mainCols, childSheets],
  );

  return {
    handleGetFreshColumns,
    handleExportInvoiceApi,
  };
};

export default useInvoiceExport;
